import { useIntersectionObserver } from 'src/common/hooks/useIntersectionObserver'
import { useAnalytics } from 'src/common/analytics'
import Section from 'src/components/shared/Section'
import Img from 'src/components/shared/Img'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'

const SlickSlider = dynamic(() =>
  import('src/components/shared/BrandPages/SlickSlider')
)

export const onViewH2Id = 'testimonial-section'

const TestimonialSection = () => {
  const router = useRouter()
  const { track } = useAnalytics()
  const { ref } = useIntersectionObserver({
    threshold: 0.8,
    freezeOnceVisible: true,
    onChange: (isIntersecting) => {
      if (!isIntersecting) return
      track(
        { additional_info: { section: onViewH2Id }, event_type: 'track' },
        {},
        'section_view'
      )
    },
  })

  const onClick = (e) => {
    e.preventDefault()

    const data = {
      click_id: 'See more reviews',
      click_text: 'FDR-Web | See more reviews',
      click_type: 'Button Click',
      click_url: '/testimonials/',
      event_action: 'click',
      event_type: 'track',
    }

    track?.(data, {}, 'button_click')

    router.push('/testimonials/')
  }

  return (
    <Section className="bg-blue-585">
      <div
        ref={ref}
        className="flex w-full flex-col items-center gap-8 font-ultramarine text-blue-135 lg:gap-12"
        data-testid="facts-testimonial-content"
      >
        <div data-testid="facts-testimonial-rating">
          <Img
            src="/next-assets/testimonials/stars.png"
            alt="stars"
            width={192}
            height={38}
            layout="intrinsic"
          />
        </div>
        <div
          className="relative mb-3 w-full"
          data-testid="facts-testimonial-list"
        >
          <SlickSlider
            classNames={` static`}
            sliderSettings={{
              dots: true,
              arrows: false,
              infinite: true,
              autoplay: true,
              speed: 700,
              autoplaySpeed: 25000,
              adaptiveHeight: false,
            }}
            name="testimonials"
          >
            {TESTIMONIALS.map((item) => (
              <div
                key={item.customerName}
                className="mb-8 flex select-text flex-col items-center gap-4"
                data-testid="facts-testimonial-item"
              >
                <p
                  className="text-center text-body-medium leading-[27.2px] lg:text-heading-3 lg:leading-[40.8px]"
                  data-testid="facts-testimonial-text"
                >
                  {item.text}
                </p>
                <div data-testid="facts-testimonial-image">
                  <Img
                    src={item.customerImage}
                    alt={'customer' + item.customerName}
                    width={72}
                    height={72}
                    layout="intrinsic"
                    imgClassName="h-[72px] w-[72px] rounded-full"
                  />
                </div>
                <p
                  className="text-sm font-medium text-[#6DCFE9] lg:text-lg"
                  data-testid="facts-testimonial-author"
                >
                  — {item.customerName}
                </p>
              </div>
            ))}
          </SlickSlider>
        </div>
        <Link
          href={'/testimonials/'}
          className="w-full lg:w-fit"
          prefetch={false}
          onClick={onClick}
          data-testid="facts-testimonial-cta-link"
        >
          <button
            className="w-full rounded-lg bg-white px-6 py-3 text-lg font-bold text-blue-585 lg:w-fit"
            data-testid="facts-testimonial-cta-button"
          >
            See more reviews
          </button>
        </Link>
        <p className="text-center text-xs" data-testid="facts-testimonial-note">
          Actual client of Freedom Debt Relief. Client’s endorsement is a
          non-paid testimonial. Individual results will vary.
        </p>
      </div>
    </Section>
  )
}

export default TestimonialSection

const TESTIMONIALS = [
  {
    customerName: 'Wanda',
    customerImage: '/next-assets/testimonials/wanda.png',
    text: '“Freedom Debt Relief has been a lifesaver. Easiest process possible and almost immediate settlement. They are quick to get back with answers to my questions and are the nicest, but professional, people I have encountered. I think Freedom understands exactly how to ease our minds when we have to ask for their help. They don’t waste time and make it so easy to approve the settlements when they email me. I would encourage anyone who is overwhelmed with debt to contact Freedom as soon as possible.”',
  },
  {
    customerName: 'Sharon',
    customerImage: '/next-assets/testimonials/sharon.png',
    text: '“Freedom from stress, freedom from burden, freedom from paying creditors monthly and coming to realize I wasn’t getting anywhere regardless of paying on time and more than the minimum payment. The most difficult part was stepping away from my normal and allowing others to help. It was terrifying in that respect, but their customer service is awesome and the dashboard is amazing!”',
  },
  {
    customerName: 'Hector',
    customerImage: '/next-assets/testimonials/hector.png',
    text: '“I would definitely recommend to a friend because it is a life changing experience. I should’ve done this a long time ago but I believe that soon I would be able to live a normal life with my family. Thank you, Freedom Debt Relief. I love you because you change people´s lives and you help them get their lives back!!!!”',
  },
]
